<template>
  <el-row class="pond-table" v-loading="loading">
    <el-row v-if="loading || Ponds.length > 0">
      <el-row type="flex" justify="end" class="action-toolbar">
        <er-input
          inputType="search"
          v-model="filters[0].value"
          size="mini"
          :placeholder="$t('Map_pond_name_search')"
          suffix-icon="el-icon-search"
        ></er-input>
        <er-button
          btnType="circle_add"
          :showLabel="true"
          :showIcon="true"
          size="mini"
          :disabled="isReadOnly"
          @click="handleAddPondClick"
        >
          <slot>
            <p style="text-transform: uppercase;">{{ $t("Comn_add_pond") }}</p>
          </slot>
        </er-button>
      </el-row>
      <el-row>
        <er-data-tables
          uniqueId="pond-settings__table"
          :key="$i18n.locale"
          :tableData="dataValues"
          :actionColumn="false"
          type="white-header-table"
          :columns="tableColumns"
          :total="total"
          :loading="loading"
          :filters="filters"
          :elTableProps="tableProps"
          :sortMethodForColumns="sortMethods()"
          :page-size="$constants.table['page-size']"
          :pagination-props="$constants.table['pagination-props']"
          @cell-click="showPondDetails"
        >
          <template v-slot:title="{ row }">{{ row.data.title }}</template>
          <template v-slot:size="{ row }">
            {{
              updatePondSizeBasedOnUnits(row.data.size, row.data.units)
                | numberWithNDigitPrecision(2)
            }}
            {{ getUserCountryName.toLowerCase() === "india" ? "ac" : "ha" }}
          </template>

          <template v-slot:cultivation_date="{ row }">
            <template v-if="row.data.status === 'ACTIVE'">
              {{
                (row.data.cultivation_date &&
                  $moment(row.data.cultivation_date).format(
                    $commonUtils.MOMENT_DATE_FORMAT_WITH_YEAR
                  )) | na
              }}
            </template>
            <template v-else>00-000 00</template>
          </template>

          <template v-slot:post_larva_stocked="{ row }">
            <template>
              {{
                row.data.post_larva_stocked
                  | commas(getUserCountryCode)
                  | na("-", true)
              }}
            </template>
          </template>

          <template v-slot:feed_template_title="{ row }">
            {{ row.data.feed_template_title | na("-") }}
          </template>

          <template v-slot:status="{ row }">
            <!-- <el-button-group v-if="row.data.status === 'ACTIVE'"> -->
            <div v-if="row.data.status === 'ACTIVE'" style="display:flex;">
              <!-- <er-button
              type="primary"
              :title="$t('Comn_edit')"
              icon="el-icon-edit"
              size="mini"
              @click="handleChangeStatus($event, 'EDIT', row.data)"
              :disabled="isReadOnly"
            ></er-button>-->
              <!-- <div
              style="width: 61.75px;"
              class="btn-container"
              @click="handleChangeStatus($event, 'EDIT', row.data)"
            >
              <img src="@/assets/pencil.svg" />
              <p>{{$t("Comn_edit")}}</p>
            </div>-->
              <div class="edit-btn-container">
                <er-button
                  type="text"
                  size="mini"
                  btnType="edit"
                  :showLabel="true"
                  :showIcon="true"
                  :disabled="isReadOnly"
                  @click="handleChangeStatus($event, 'EDIT', row.data)"
                ></er-button>
              </div>
              <!-- <div class="btn-container" @click="handleChangeStatus($event, 'RESET', row.data)">
              <img src="@/assets/trash.svg" />
              <p>{{$t("Comn_delete")}}</p>
            </div>-->
              <el-divider
                direction="vertical"
                style="height:100%;"
              ></el-divider>

              <er-button
                type="text"
                size="mini"
                btnType="delete"
                :showLabel="true"
                :showIcon="true"
                :disabled="isReadOnly"
                @click="handleChangeStatus($event, 'RESET', row.data)"
              ></er-button>
            </div>
            <div v-else style="display:flex;">
              <!-- <div class="btn-container" @click="handleChangeStatus($event, 'ACTIVE', row.data)">
              <img src="@/assets/tick.svg" />
              <p>{{$t("Activate")}}</p>
            </div>-->
              <div class="edit-btn-container">
                <er-button
                  type="text"
                  size="mini"
                  btnType="activate"
                  :showLabel="true"
                  :showIcon="true"
                  :disabled="isReadOnly"
                  @click="handleChangeStatus($event, 'ACTIVE', row.data)"
                ></er-button>
              </div>
              <!-- <div class="btn-container" @click="handleChangeStatus($event, 'RESET', row.data)">
              <img src="@/assets/trash.svg" />
              <p>{{$t("Comn_delete")}}</p>
            </div>-->
              <el-divider
                direction="vertical"
                style="height:100%;"
              ></el-divider>
              <er-button
                type="text"
                size="mini"
                btnType="delete"
                :showLabel="true"
                :showIcon="true"
                :disabled="isReadOnly"
                @click="handleChangeStatus($event, 'RESET', row.data)"
              ></er-button>
            </div>
          </template>
        </er-data-tables>
      </el-row>
      <component
        :is="`cultureActionDialog`"
        :showDialog="dialogVisible"
        :pond="selectedPond"
        :actionToPerform="actionToPerform"
        @close_dialog="closeDialog"
      ></component>
    </el-row>
    <er-no-ponds :tabData="tabData" :disabled="isReadOnly" v-else />
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import cultureActionDialog from "./cultureActionDialog";
import Pond from "@/model/pond";
import filtersMixin from "@/mixins/filtersMixin.js";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  mixins: [errorHandlerMixin, filtersMixin, notificationMixin],
  components: {
    cultureActionDialog
  },
  props: {
    tabData: {
      default: {}
    }
  },
  data: function() {
    return {
      data: [],
      total: 0,
      loading: true,
      selectedPond: new Pond(),
      actionToPerform: "",
      dialogVisible: false,
      currentFilters: new Map(),
      multiSeletedPonds: [],
      tableProps: {
        // border: true,
        size: "small",
        // height:250,
        defaultSort: {
          prop: "title",
          order: "ascending"
        }
      },
      disabled: true,
      filters: [
        {
          value: "",
          filterFn: (row, filter) => {
            return row.title.toLowerCase().includes(filter.value.toLowerCase());
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters("pond", {
      Ponds: "getPonds"
    }),
    ...mapGetters("user", {
      getUserCountryName: "getUserCountryName",
      getUserCountryCode: "getUserCountryCode",
      getUserLocationsObj: "getUserLocationsObj",
      getCurrUserLocation: "getCurrUserLocation",
      isReadOnly: "isReadOnly"
    }),
    ...mapGetters("schedules", {
      getMapPondIdFT: "getMapPondIdFT"
    }),

    tableColumns() {
      return {
        title: {
          prop: "title",
          label: this.$t("Comn_pond_name"),
          sortable: "custom",
          minWidth: 100
        },
        size: {
          prop: "size",
          label: this.$tc("Pond_size", 1),
          sortable: "custom",
          minWidth: 100
        },
        cultivation_date: {
          prop: "cultivation_date",
          label: this.$t("Comn_stocking_date"),
          sortable: "custom",
          minWidth: 100
        },
        post_larva_stocked: {
          prop: "post_larva_stocked",
          label: this.$t("Pond_pls_stocked"),
          sortable: "custom",
          minWidth: 100
        },
        feed_template_title: {
          prop: "feed_template_title",
          label: this.$t("PM_pond_feeding_set"),
          sortable: "custom",
          minWidth: 100
        },
        status: {
          prop: "status",
          label: `${this.$t("Comn_actions")}`,
          minWidth: 100
        }
      };
    },
    dataValues() {
      return Object.values(this.data).sort((pm1, pm2) => {
        return this.$commonUtils.alphaNumericComparator(pm1.title, pm2.title);
      });
    },
    updatePondSizeBasedOnUnits() {
      return (size, units) => {
        const userLocation = this.getUserCountryName.toLowerCase();
        if (userLocation === "india") {
          return Number(
            this.$commonUtils.castPondAreaSize(size, units, "ac")
          ).toFixed(2);
        }
        return Number(
          this.$commonUtils.castPondAreaSize(size, units, "ha")
        ).toFixed(2);
      };
    },
    isDeleteEnable() {
      return pond => {
        return (
          pond.pond_mothers.length > 0 ||
          pond.pond_guards.length > 0 ||
          pond.shrimp_talks.length > 0
        );
      };
    }
  },
  mounted() {
    this.loadPondsList();
  },
  methods: {
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds",
      updatePondDetails: "updatePondDetails"
    }),
    ...mapActions("schedules", {
      fetchAllFeedTemplates: "fetchAllFeedTemplates"
    }),
    sortMethods() {
      return {
        title: this.sortPondWise,
        cultivation_date: this.sortByCultivationDate,
        feed_template_title: this.sortTemplateWise
      };
    },
    sortTemplateWise(a, b) {
      return this.$commonUtils.alphaNumericComparator(a, b);
    },
    sortPondWise(a, b) {
      return this.$commonUtils.alphaNumericComparator(a, b);
    },
    sortByCultivationDate(a, b) {
      const aCulDate = a || this.$commonUtils.minDateISOString;
      const bCulDate = b || this.$commonUtils.minDateISOString;
      return this.$moment(aCulDate).diff(this.$moment(bCulDate));
    },
    closeDialog(event) {
      this.dialogVisible = false;
      if (event !== "close") {
        this.loadPondsList();
      }
    },
    doesPondHasDevices: function(row, index) {
      if (row.pond_mothers.length > 0) {
        return true;
      }
      return false;
    },
    loadPondsList: async function() {
      this.loading = true;
      try {
        const response1 = await this.fetchAllPonds({
          location_id: this.getCurrUserLocation._id,
          get_all: true
        });
        const ftquery = {
          location_id: this.getCurrUserLocation._id
        };
        await this.fetchAllFeedTemplates(ftquery);
        this.data = this.$lodash
          .cloneDeep(this.Ponds)
          .map(x => {
            x.feed_template_title = (
              this.getMapPondIdFT[x._id] || { title: undefined }
            ).title;
            return x;
          })
          .sort((a, b) =>
            this.$commonUtils.alphaNumericComparator(a.title, b.title)
          );
        this.total = response1.totalPonds;
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    showPondDetails(row, column, cell, event) {
      if (
        column.property === this.tableColumns.title.prop &&
        row.status === "ACTIVE"
      ) {
        this.$router.push({
          path: "pond-details",
          query: { pondId: row.pond_id }
        });
      }
    },
    handleSelectionChange(arrSelectedPonds) {
      this.multiSeletedPonds = arrSelectedPonds;
    },
    async handleChangeStatus(event, action, pond) {
      try {
        if (!this.isDeleteEnable(pond) && action === "RESET") {
          this.canUserDelete(this.tabData);

          this.$notify({
            title: this.$t("failed"),
            message: this.$t("no_devices_pond_clear"),
            type: "error"
          });
          return;
        }
        this.isEditable(this.tabData);

        if (["INACTIVE", "RESET"].indexOf(action) > -1) {
          let { pond_id, status } = pond;
          status = action;
          try {
            await this.deleteConfirmation(pond.title, "table");
            await this.notificationHandler({ pond_id, status });
          } catch (err) {
            console.log(err);
          }
        } else {
          this.selectedPond = this.$lodash.cloneDeep(pond);
          this.dialogVisible = true;
          this.actionToPerform = action;
        }
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    async notificationHandler(reqPayload) {
      try {
        const response = await this.updatePondDetails(reqPayload);
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: response.message,
          duration: 5000,
          type: "success"
        });
        this.loadPondsList();
      } catch (err) {
        // this.errorMessages(err, true);
        this.$notify({
          title: this.$t("failed"),
          message: err.message,
          duration: 5000,
          type: "error"
        });
      }
    },
    handleAddPondClick() {
      try {
        this.isEditable(this.tabData);
        this.$router.push("map-view");
      } catch (error) {
        this.errorMessages(error, true);
      }
    }
  }
};
</script>

<style lang="scss">
.pond-table {
  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  #pond-settings__table {
    padding: 0 12px;
  }
  .row-status-container {
    cursor: pointer;
    display: flex;
    align-content: center;
    .btn-container {
      margin-right: 16px;
      display: flex;
      align-items: center !important;
      text-transform: uppercase;
    }
    img {
      width: 12px;
      margin-right: 8px;
    }
    div {
      display: flex;
    }
    p {
      font-size: 9px;
    }
  }
  .action-toolbar {
    padding-bottom: 12px;
    padding-top: 12px;
    padding-right: 10px;
    // background: white;
  }
  .el-pagination__sizes {
    .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
  }
  .el-pagination__total {
    margin-left: 20px;
  }
  .pagination-bar {
    margin-bottom: 10px;
  }

  .action-btn {
    .img {
      display: inline-flex;
    }
    .material-icons-round {
      font-size: 12px;
    }
  }

  .edit-btn-container {
    width: 56.61px;
    @include responsiveProperty(width, 56.62px, 66px, 80.7px);
    display: flex;
  }
}
</style>